// Para birimi yardımcıları. API her fiyatı 3 para biriminde döndürür
// (priceEuro/priceTL/priceUsd ve ana sayfada minPriceEuro/minPriceTL/minPrice),
// bu yüzden dönüştürme yapmayız — sadece seçili para biriminin alanını seçeriz.

// NOT: Listeleme ekranlarında her zaman standart fiyat alanını (EUR'da priceEuro)
// gösteririz. Tahsil edilen tutar EUR'da `versionedPriceEur`'dur, ama o yalnızca
// ödeme akışında (checkout'a geçerken PlanDetail'de) kullanılır — listede değil.
// `v2Field`: /v2/bundles planları fiyatları farklı adlarla döndürür
// (priceEur/priceTry/priceUsd). Eski uçların alan adları korunuyor.
export const CURRENCIES = [
  { code: 'EUR', symbol: '€', priceField: 'priceEuro', minField: 'minPriceEuro', v2Field: 'priceEur' },
  { code: 'TRY', symbol: '₺', priceField: 'priceTL', minField: 'minPriceTL', v2Field: 'priceTry' },
  { code: 'USD', symbol: '$', priceField: 'priceUsd', minField: 'minPrice', v2Field: 'priceUsd' },
];

export const DEFAULT_CURRENCY = 'EUR';

export const getCurrencyMeta = (code) =>
  CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];

// Sayısal değeri seçili para biriminin sembolüyle biçimler. (₺120 → ₺120,00)
export const formatPrice = (value, code) => {
  const n = parseFloat(value);
  if (value == null || Number.isNaN(n)) return null;
  const { symbol } = getCurrencyMeta(code);
  const formatted = n.toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol}${formatted}`;
};

// Bir refill/obje üzerinden seçili para biriminin gösterim fiyatını alır.
export const pickPrice = (obj, code) => obj?.[getCurrencyMeta(code).priceField];

// /v2 planı (bundle.plans[]) için seçili para biriminin gösterim fiyatı.
// NOT: Bunlar Google'ın ürettiği VERGİ DAHİL gösterim fiyatlarıdır;
// `basePriceTry` admin alanıdır ve kullanıcıya gösterilmez.
export const pickPlanPrice = (plan, code) => plan?.[getCurrencyMeta(code).v2Field];

// Bir bundle'ın planları içindeki en düşük (pozitif) fiyat, her para biriminde.
export const minPlanPrices = (plans) => {
  const out = {};
  CURRENCIES.forEach(({ code }) => {
    let min = null;
    (plans || []).forEach((p) => {
      const v = parseFloat(pickPlanPrice(p, code));
      if (!Number.isNaN(v) && v > 0) min = min == null || v < min ? v : min;
    });
    out[code] = min;
  });
  return out;
};

// Bir ülkenin paketleri içindeki en düşük (pozitif) fiyatı seçili para biriminde.
export const minPriceOf = (products, code) => {
  let min = null;
  (products || []).forEach((p) =>
    (p.refills || []).forEach((r) => {
      const v = parseFloat(pickPrice(r, code));
      if (!Number.isNaN(v) && v > 0) min = min == null || v < min ? v : min;
    })
  );
  return min;
};
